const ShippingInstructions = (props) => {
  const { shippingInstructions } = props;
  if (!shippingInstructions) {
    return null;
  }
  return (
    <span>
      <strong>Shipping Instructions</strong>
      <br />
      {shippingInstructions}
    </span>
  );
};

export default ShippingInstructions;
